var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"customer_show_core_waybill"}},[(_vm.is_initialized)?_c('CoreWaybill',{attrs:{"core_waybill":_vm.core_waybill,"template":'detail',"scope":'customer',"statuses":_vm.statuses,"is_auto_print":false,"is_can_update":_vm.current_customer.is_modification_allowed,"is_can_print_label":true,"is_show_change_template_btns":_vm.current_customer.is_modification_allowed,"detail":{
            is_show_blood_related: true,
            is_show_receipt_file: true,
            is_show_partition: true,
            is_show_statuses: true,
        }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }